module.exports = __webpack_public_path__ + "static/media/mira-cgi-map-top-view.9761639a.jpg";